module.exports = __webpack_public_path__ + "img/p2-78.6ad4c045.png";